import api from "./transactionApi";
import type { TransactionYear } from "../../repsaApi";
import {
  transactionYearsLoading,
  transactionYearsLoadingError,
  transactionYearsLoaded,
  transactionYearCreating,
  transactionYearCreatingError,
  transactionYearCreated,
  transactionYearDeleting,
  transactionYearDeleted,
  transactionYearDeletingError,
  resetTransactionYearDeleteState,
  resetTransactionYearCreateState,
} from "./transactionYearStateActions";
import { ITransactionYearModel } from "../../../types/types";

export function fetchTransactionYears() {
  return function (dispatch: any) {
    dispatch(transactionYearsLoading());
    api.getTransactionYears().then(
      (data: TransactionYear[]) =>
        dispatch(
          transactionYearsLoaded(
            data.map(
              (item) => ({ ...item, id: item.id } as ITransactionYearModel)
            )
          )
        ),
      (error: Error) => dispatch(transactionYearsLoadingError(error.message))
    );
  };
}

export function createTransactionYear(year: number) {
  return function (dispatch: any) {
    dispatch(transactionYearCreating());
    api
      .createTransactionYear(year)
      .then(
        (response) => {
          dispatch(
            transactionYearCreated({
              year,
              transactionCount: 0,
              id: response,
            } as TransactionYear)
          );
        },
        (error) => {
          dispatch(
            transactionYearCreatingError(
              error.response?.message ?? error.message
            )
          );
        }
      )
      .finally(function () {
        setTimeout(() => {
          dispatch(resetTransactionYearCreateState());
        }, 500);
      });
  };
}

export function deleteTransactionYear(id: number) {
  return function (dispatch: any) {
    dispatch(transactionYearDeleting());
    api
      .deleteTransactionYear(id)
      .then(
        (result) => {
          if (result > 0) {
            dispatch(transactionYearDeleted(id));
          } else {
            dispatch(
              transactionYearDeletingError("Failed to delete transaction year")
            );
          }
        },
        (error: Error) => dispatch(transactionYearDeletingError(error.message))
      )
      .finally(function () {
        setTimeout(() => {
          dispatch(resetTransactionYearDeleteState());
        }, 500);
      });
  };
}
